<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="$t.__('email.ScheduleEmailDialog.title')"
        class="schedule-email-dialog"
        :primaryAction="primaryAction"
        :secondaryActions="secondaryActions"
        @closed="$emit('close')"
    >
        <template slot="default">
            <CompassAlert
                v-if="isInvalidDateTime"
                type="error"
                :description="$t.__('email.ScheduleEmailDialog.error')"
                :showClose="false"
            />
            <p class="typographies-paragraph-medium-regular">
                {{ $t.__('email.ScheduleEmailDialog.description') }}
            </p>
            <div class="schedule-email-dialog__form">
                <CompassFormItem label="Date">
                    <CompassDatePicker
                        v-model="scheduleDate"
                        :formatDateDisplayed="formatDateDisplayed"
                        datePickerClass="schedule-email-dialog__datepicker"
                        :calendarOptions="{
                            lang: uiLang,
                            disablePast: true,
                        }"
                        class="schedule-email-dialog__date-input"
                        @update:value="handleUpdateDate"
                    />
                </CompassFormItem>
                <CompassFormItem label="Heure">
                    <CompassTimePicker
                        :key="`schedule-time-${scheduleDate}`"
                        v-model="scheduleTime"
                        :hourFormat="hourformat"
                        :min="minTime"
                        class="schedule-email-dialog__timepicker"
                        autoScroll
                        @update:value="handleTimeUpdate"
                    />
                </CompassFormItem>
            </div>
        </template>
    </CompassDialog>
</template>
<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';

const { mapState: corpMapState } = createNamespacedHelpers('corp');
export default {
    props: {
        visible: {
            type: Boolean,
        },
    },
    data() {
        return {
            showModal: this.visible,
            scheduleDate: moment().format('YYYY-MM-DD'),
            scheduleTime: moment().add(5, 'm').format('HH:mm'),
            minTime: moment().add(1, 'm').format('HH:mm'),
            isInvalidDateTime: false,
            primaryAction: {
                label: this.$t.__('email.ScheduleEmailDialog.primary_action'),
                action: () => this.scheduleEmail(),
            },
            secondaryActions: [
                {
                    label: this.$t.__('common.actions.cancel'),
                    action: () => {
                        this.$emit('close');
                    },
                },
            ],
        };
    },
    computed: {
        ...corpMapState(['uiLang', 'timeformat', 'hourformat']),
        formatDateDisplayed() {
            return this.timeformat === 'dmy' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
        },
    },
    watch: {
        visible(newValue) {
            this.showModal = newValue;
        },
    },
    methods: {
        scheduleEmail() {
            this.validateDateAndTime();

            if (this.isInvalidDateTime) {
                return;
            }
            const finalDate = moment(`${this.scheduleDate} ${this.scheduleTime}`).toISOString();
            this.$emit('scheduled', finalDate);
        },
        handleUpdateDate(date) {
            if (moment(date).isSame(moment(), 'day')) {
                this.minTime = moment().add(5, 'm').format('HH:mm');
            } else {
                this.minTime = moment(this.scheduleDate).format('HH:mm');
            }
            this.validateDateAndTime();
        },
        handleTimeUpdate() {
            this.validateDateAndTime();
        },
        validateDateAndTime() {
            const scheduleDateTime = moment(`${this.scheduleDate} ${this.scheduleTime}`);
            this.isInvalidDateTime = scheduleDateTime.isSameOrBefore(moment());
        },
    },
};
</script>
<style lang="scss" scoped>
.schedule-email-dialog {
    &__form {
        display: flex;
        gap: var(--spacing-4);

        &::v-deep {
            .compass-form-item {
                flex: 1;
            }

            .compass-input {
                width: 100%;
            }
        }
    }
}
</style>
